import { SubscriptionPlan } from '@getaccept/lib-shared/src/enums/subscription-plan';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

import { SeatType } from '../types/seat-type';
import { SubscriptionStatus } from '../types/subscription-status';

export class SubscriptionConstants {
  static tabs = () => [
    {
      label: t('trial_plan_full_suite'),
      key: SeatType.Suite,
      dataExternal: 'subscription-modal-full-suite-tab',
    },
    {
      label: t('trial_plan_contract_room'),
      key: SeatType.ContractRoom,
      dataExternal: 'subscription-modal-contract-room-tab',
    },
    {
      label: t('trial_plan_deal_room'),
      key: SeatType.DealRoom,
      dataExternal: 'subscription-modal-deal-room-tab',
    },
  ];

  static professionalChecklist = (module: SeatType) => {
    switch (module) {
      case SeatType.ContractRoom:
        return [
          t('trial_plan_unlimited_electronic_signatures'),
          t('trial_plan_branding_and_templates'),
          t('trial_plan_advanced_tracking_and_insights'),
        ];
      case SeatType.DealRoom:
      case SeatType.Suite:
        return [
          t('trial_plan_unlimited_active_rooms'),
          t('trial_plan_content_management'),
          t('trial_plan_advanced_tracking_and_insights'),
        ];
      default:
        return [];
    }
  };

  static enterpriseChecklist = (module: SeatType) => {
    switch (module) {
      case SeatType.ContractRoom:
        return [
          t('Contract management'),
          t('trial_plan_cpq_and_product_library'),
          t('trial_plan_single_sign-on'),
        ];
      case SeatType.DealRoom:
      case SeatType.Suite:
        return [
          t('trial_plan_cpq_and_product_library'),
          t('trial_plan_single_sign-on'),
          t('trial_plan_premium_integrations'),
        ];

      default:
        return [];
    }
  };

  static formattedPlanName = (plan: SubscriptionPlan) => {
    switch (plan) {
      case SubscriptionPlan.Esign:
        return t('esign-plan');
      case SubscriptionPlan.WebTrial:
        return t('webtrial-plan');
      case SubscriptionPlan.SalesTrial:
        return t('salestrial-plan');
      case SubscriptionPlan.Professional:
        return t('professional-plan');
      case SubscriptionPlan.Enterprise:
        return t('enterprise-plan');

      // Legacy plans
      case SubscriptionPlan.Free:
        return t('free-plan');
      case SubscriptionPlan.Essential:
        return t('essential-plan');
      case SubscriptionPlan.EnterprisePlus:
        return t('enterpriseplus-plan');
      case SubscriptionPlan.Trial:
        return t('trial-plan');
      case SubscriptionPlan.Solo:
        return t('solo-plan');
      case SubscriptionPlan.Starter:
        return t('starter-plan');
      case SubscriptionPlan.Business:
        return t('business-plan');
      case SubscriptionPlan.Pro:
        return t('pro-plan');
      case SubscriptionPlan.Partner:
        return t('partner-plan');
      default:
        return plan;
    }
  };

  static formattedStatus = (status: SubscriptionStatus) => {
    switch (status) {
      case SubscriptionStatus.Active:
      case SubscriptionStatus.InTrial:
        return t('subscription_plan_active');
      case SubscriptionStatus.Cancelled:
        return t('add_seats_badge_cancelled');
      case SubscriptionStatus.Expired:
        return t('expired');
      default:
        return '';
    }
  };
}
